export { toShorthandSize } from './tShirtSizes';